module.exports = __webpack_public_path__ + "img/company48.1753ca24.png";